"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative",
    width: props => {
      return props.width;
    },
    height: props => {
      return props.height;
    },
    //        backgroundColor: props => { return props.backgroundColor || theme.palette.action.selected },
    margin: "0"
  },
  cropbox: {
    display: "block",
    position: "absolute",
    //        backgroundColor: "grey",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "auto",
    overflow: "hidden",
    opacity: "1",
    transformOrigin: "50% 50%",
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1)",
    transform: "scale(1)",
    userSelect: "none",
    "&[aria-selected=true]": {
      transform: "scale(0.8)"
    }
  },
  image: {
    display: "block",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    maxWidth: props => {
      return props.maxWidth;
    },
    maxHeight: props => {
      return props.maxHeight;
    },
    margin: "auto"
  }
}));

const ModuleMedia = (_ref) => {
  let className = _ref.className,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      imageUrl = _ref.imageUrl,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "contain" : _ref$layout,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "56px" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "56px" : _ref$height,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "100%" : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? "100%" : _ref$maxHeight,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "elevation", "selected", "imageUrl", "layout", "width", "height", "maxWidth", "maxHeight", "margin", "onClick"]);

  const classes = useStyles(_extends({}, props, {
    width,
    height,
    maxWidth,
    maxHeight,
    margin
  }));
  const coverStyle = {
    backgroundPosition: "50% 50%",
    backgroundImage: "url(" + imageUrl + ")",
    backgroundSize: layout,
    backgroundRepeat: "no-repeat"
  };

  if (selected) {
    elevation = elevation * 4;
  }

  if (layout === "cover") {
    return _react.default.createElement("div", {
      className: className || classes.root,
      "aria-selected": selected,
      onClick: onClick
    }, _react.default.createElement(_Paper.default, {
      component: "figure",
      className: classes.cropbox,
      "aria-selected": selected,
      style: coverStyle,
      square: true,
      elevation: elevation
    }, _react.default.createElement("img", {
      src: imageUrl,
      className: classes.image,
      style: {
        display: "none"
      }
    })));
  }

  return _react.default.createElement("div", {
    className: className || classes.root,
    "aria-selected": selected,
    onClick: onClick
  }, _react.default.createElement(_Paper.default, {
    component: "figure",
    className: classes.cropbox,
    "aria-selected": selected,
    square: true,
    elevation: elevation
  }, _react.default.createElement("img", {
    src: imageUrl,
    className: classes.image
  })));
};

ModuleMedia.propTypes = process.env.NODE_ENV !== "production" ? {
  imageUrl: _propTypes.default.string,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  margin: _propTypes.default.string
} : {};
var _default = ModuleMedia;
exports.default = _default;
module.exports = exports.default;